import { loadImage } from 'mixtiles-web-common/services/imageLoader'
import {
  canvasToBlobUrl,
  releaseCanvas,
} from 'mixtiles-web-common/services/canvasService'
import { logger } from './logger'
import { isClient } from '../utils/runtimeUtils'

export const calculateThumbSizeForRatio = (width, height, thumbSize) => {
  const imageAspectRatio = width / height

  let resultWidth = thumbSize
  let resultHeight = resultWidth / imageAspectRatio

  if (resultWidth > width) {
    resultWidth = width
    resultHeight = width / imageAspectRatio
  } else if (resultHeight > height) {
    resultHeight = height
    resultWidth = height * imageAspectRatio
  }

  return { width: resultWidth, height: resultHeight }
}

const canvas = isClient() ? document.createElement('canvas') : undefined

/**
 * @param {{
 *   image: CanvasImageSource
 *   width: number
 *   height: number
 *   thumbDimensions: { width: number, height: number }
 *   shouldLoadImage?: boolean
 *   type?: string
 *   quality?: number
 * }} params
 */
export const createThumbWithRatio = async ({
  image,
  width,
  height,
  thumbDimensions,
  shouldLoadImage = false,
  type = 'image/png',
  quality,
}) => {
  logger.info('createThumbWithRatio', {
    width,
    height,
    thumbDimensions,
  })

  canvas.width = thumbDimensions.width
  canvas.height = thumbDimensions.height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(image, 0, 0, width, height, 0, 0, canvas.width, canvas.height)

  const { blobUrl, blob } = await canvasToBlobUrl(canvas, type, quality)

  let thumb = null

  if (shouldLoadImage) {
    thumb = await loadImage(blobUrl)
  }

  releaseCanvas(canvas)
  return {
    thumbImage: thumb,
    thumbUrl: blobUrl,
    thumbDimensions,
    blob,
  }
}
